
<div *ngIf="show && (pendingTransactions$ | async)?.length" @fadeInOut  
     class="running-integration-message success"
     
>
  <img
       class="message-icon"
       src="assets/icons/icon-danger-circle-white.svg"
       alt="loading"
  />

  <div class="content">
    <div class="message-header">Pending Transactions</div>

    <div class="message-text">
      You have {{(pendingTransactions$ | async)?.length}} pending transactions ready for confirmation
    </div>
  </div>

  <img 
       class="close-icon animation-focus-default"
       src="assets/icons/icon-close-white.svg"
       alt="close"
       (click)="show = false"
  />
</div>
